import PropTypes from 'prop-types'
import Icon from '../../icons/Icon.js'

export default function ButtonRefresh({onClick}) {
  return (
    <button
      className="btn btn--link no-underline meta-orderlistheader-button-refreshorderlist lh-0"
      type="button"
      onClick={onClick}
    >
      <Icon
        name="refresh"
        className="fs-01 lh-0 v-align-middle margin-left-3"
      />
    </button>
  )
}

ButtonRefresh.propTypes = {
  onClick: PropTypes.func.isRequired,
}
